import { InMemoryCacheConfig } from '@apollo/client';
import uniqBy from '~/helpers/objects';

const typePolicies: InMemoryCacheConfig['typePolicies'] = {
    Indicator: {
        keyFields: false,
    },

    TopFiveNonComplianceBySymptom: {
        keyFields: false,
    },

    TopFiveAverageDurationBySymptom: {
        keyFields: false,
    },
    DailyFlowReadings: {
        keyFields: false,
    },
    RequestsActAndDangerList: {
        keyFields: false,
    },
    MunicipalityTotalizers: {
        keyFields: false,
    },
    InfrastructureVariablesTree: {
        keyFields: ['id'],
    },
    Query: {
        fields: {
            sintomas_causas_trabalhos: {
                keyArgs: ['$where'],
                // eslint-disable-next-line
                merge: (existing = [], incoming, { readField }) =>
                    uniqBy([...existing, ...incoming], (item) =>
                        readField('id', item)
                    ),
            },
            base_infraestruturas: {
                keyArgs: ['$where'],
                // eslint-disable-next-line
                merge: (existing = [], incoming, { readField }) =>
                    uniqBy([...existing, ...incoming], (item) =>
                        readField('id', item)
                    ),
            },
            servicos_intervencoes: {
                keyArgs: ['$where'],
                // eslint-disable-next-line
                merge: (existing = [], incoming, { readField }) =>
                    uniqBy([...existing, ...incoming], (item) =>
                        readField('id', item)
                    ),
            },
            variaveis_fontes_origem: {
                keyArgs: ['$where'],
                // eslint-disable-next-line
                merge: (existing = [], incoming, { readField }) =>
                    uniqBy([...existing, ...incoming], (item) =>
                        readField('id', item)
                    ),
            },
            utilizadores_utilizadores: {
                keyArgs: ['$search'],
                // eslint-disable-next-line
                merge: (existing = [], incoming, { readField }) =>
                    uniqBy([...existing, ...incoming], (item) =>
                        readField('id', item)
                    ),
            },
            tarefas_planos_padrao: {
                keyArgs: ['$where'],
                // eslint-disable-next-line
                merge: (existing = [], incoming, { readField }) =>
                    uniqBy([...existing, ...incoming], (item) =>
                        readField('id', item)
                    ),
            },
            navia_dashboards_caudais_diarios_municipios: {
                keyArgs: ['$where'],
                // eslint-disable-next-line
                merge: (existing = [], incoming, { readField }) =>
                    uniqBy([...existing, ...incoming], (item) =>
                        readField('id', item)
                    ),
            },
            variaveis_base: {
                keyArgs: ['$where'],
                // eslint-disable-next-line
                merge: (existing = [], incoming, { args, readField }) => {
                    if (!args?.offset) return incoming;
                    return uniqBy([...existing, ...incoming], (item) =>
                        readField('id', item)
                    );
                },
            },
            infrastructure_variables_tree: {
                keyArgs: [
                    'transactionId',
                    'typeIds',
                    'infrastructureSearchText',
                    'variableSearchText',
                ],
                merge(_existing, incoming) {
                    return incoming; // replace fully on each fetch
                },
            },
        },
    },
};

export default typePolicies;
